import axios from 'axios';
import { t } from 'i18next';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import baseURL from '../../../components/helper/axiosHelper';

const Button = ({ text, color, onClick, style }) => (
  <button
    className={`bg-${color}-500 hover:bg-${color}-700 active:bg-${color}-800 px-4 py-2 rounded-md`}
    onClick={onClick}
    style={style}
  >
    {text}
  </button>
);

const token = localStorage.getItem('token');

export function GiftTable(props) {
  const [showModal, setShowModal] = useState(false);
  const { headers, rows, whiteListKeys, setRefresh } = props;
  const isActive = useSelector((state) => state.toggle.isActive);

  const handlerStatus = async (row) => {
    try {
      if (row) {
        const response = await axios.put(
          `${baseURL}/GiftService/UpdateSettingsGiftType`,
          {
            giftTypeID: row['giftTypeID'],
            activeID: row['activeID'] === 1 ? 2 : 1,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (row['activeID'] === 1) {
          toast.success(t('Deactivated'));
        } else {
          toast.success(t('Activated'));
        }
        setRefresh();
      }
    } catch (error) {
      toast.error(t('Something went wrong, Please try again!'));
    }
  };

  const handleRowIndexClick = (index) => {};

  return (
    <div className="my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div className="py-2 align-middle  inline-block min-w-full sm:px-6 lg:px-8">
        <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-customgreen  text-white">
              <tr>
                {headers.map((header, index) => (
                  <th key={index} scope="col-2" className="px-6 py-3 text-sm font-medium uppercase  whitespace-nowrap ">
                    {t(`${header}`)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white text-sm divide-y divide-gray-200">
              {rows.map((row, rowIndex) => (
                <tr key={rowIndex} onClick={() => handleRowIndexClick(rowIndex)}>
                  <td className="px-6 py-4 whitespace-nowrap  text-gray-500">{rowIndex + 1}</td>
                  <td className="px-6 py-4 whitespace-nowrap  text-gray-500">
                    {isActive ? row['ar_SA'] : row['en_US']}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap  text-gray-500">
                    <Button
                      text={t(`${row['activeID'] === 1 ? 'Activate' : 'Deactivate'}`)}
                      color={row['activeID'] === 1 ? 'green' : 'red'}
                      onClick={() => handlerStatus(row)}
                      style={
                        row['activeID'] === 1
                          ? { backgroundColor: '#06703A', color: '#fff' }
                          : { backgroundColor: '#06703A ', color: '#fff' }
                      }
                      className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen    rounded-full px-5 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen"
                    />
                  </td>
                  <td className="px-6 py-4  whitespace-nowrap  text-gray-500">
                    <Link to={`/add-gift/${row['giftTypeID']}/${row['en_US']}`}>
                      <button className="focus:outline-none text-white bg-customgreen hover:bg-hovergreen focus:ring-4 focus:ring-customgreen   mt-2  rounded-full w-[200px] px-4 py-2.5 me-2 mb-2 dark:bg-customgreen dark:hover:bg-hovergreen dark:focus:ring-customgreen">
                        {t('Add projects')}
                      </button>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
